/*
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-21 15:45:45
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-26 16:37:10
 * @FilePath: /wemeet-admin-new/src/views/recruitment/context.js
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
 */

// 岗位状态
export const JOB_STATUS = {
  UN_PUBLISHED: 'UN_PUBLISHED',
  PUBLISHED: 'PUBLISHED',
  FULLY_RECRUITED: 'FULLY_RECRUITED',
  REMOVED: 'REMOVED',
}

export const JOB_STATUS_CN = {
  [JOB_STATUS.UN_PUBLISHED]: '未发布',
  [JOB_STATUS.PUBLISHED]: '已发布',
  [JOB_STATUS.FULLY_RECRUITED]: '已招满',
  [JOB_STATUS.REMOVED]: '下架',
}

// 结算方式
export const SETTLEMENT = {
  MONTH: 'MONTH',
  DATE: 'DATE',
  HOUR: 'HOUR',
}

export const SETTLEMENT_CN = {
  [SETTLEMENT.MONTH]: '月薪',
  [SETTLEMENT.DATE]: '日薪',
  [SETTLEMENT.HOUR]: '时薪',
}

// 薪资单位
export const SALARY_UNIT = {
  [SETTLEMENT.MONTH]: 'K',
  [SETTLEMENT.DATE]: '元/天',
  [SETTLEMENT.HOUR]: '元/时',
}

// 薪资展示倍数
export const SALARY_SCALE = {
  [SETTLEMENT.MONTH]: 1000,
  [SETTLEMENT.DATE]: 1,
  [SETTLEMENT.HOUR]: 1,
}

// 推荐人状态
export const RECOMMENDER_STATUS = {
  IN_USE: 'IN_USE',
  DEACTIVATE: 'DEACTIVATE',
}

export const RECOMMENDER_STATUS_CN = {
  [RECOMMENDER_STATUS.IN_USE]: '使用中',
  [RECOMMENDER_STATUS.DEACTIVATE]: '停用',
}

// 人才状态
export const TALENT_STATUS = {
  ALREADY_EMPLOYED: 'ALREADY_EMPLOYED',
  DEPARTURE: 'DEPARTURE',
  NOT_HIRED: 'NOT_HIRED',
  DELIVERY: 'DELIVERY',
}

export const TALENT_STATUS_CN = {
  ALREADY_EMPLOYED: '已入职',
  DEPARTURE: '已离职',
  NOT_HIRED: '未入职',
  DELIVERY: '已投递，未反馈',
}

// 导出配置
export const exportType = {
  // 推荐人全量导出
  RECOMMENDER_ALL: 'ENTERPRISE_USER_JOB_RECOMMENDATION_ALL',
  // 推荐人单条数据导出
  RECOMMENDER_CHANNEL: 'ENTERPRISE_USER_JOB_RECOMMENDATION',
  // 人才库导出
  ENTERPRISE_USER_JOB: 'ENTERPRISE_USER_JOB',
}

// 提现状态
export const WITHDRAWAL_STATUS = {
  UNCONFIRMED: 'UNCONFIRMED',
  AUDIT: 'AUDIT',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  BANK_REJECTED: 'BANK_REJECTED',
  PAID: 'PAID',
  PAY_ERROR: 'PAY_ERROR',
}

export const WITHDRAWAL_STATUS_CN = {
  UNCONFIRMED: '待确认',
  AUDIT: '待审核',
  PENDING: '待支付',
  REJECTED: '被拒绝',
  BANK_REJECTED: '收款账户问题',
  PAID: '已支付',
  PAY_ERROR: '支付失败',
}
